import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";

export default function setupElement() {
    // 设置语言为英文
    locale.use(lang);
}
